/**
 * Инструкция к экрану: кнопка в шапке и панель справа с текстом из `web/src/help/<экран>.md`.
 * Фона-затемнения нет — инструкцию читают, глядя на таблицу и щёлкая по ней.
 */
import { BookOpen, X } from "lucide-react";
import { useEffect } from "react";

import { Prose } from "@/components/Prose";

export function HelpButton({ onClick, className = "" }: { onClick: () => void; className?: string }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex items-center gap-1.5 rounded-[var(--radius-ui)] border border-border px-2.5 py-1 text-[12.5px] text-fg-muted hover:bg-bg-hover hover:text-fg ${className}`}
      data-annot="кнопка инструкции"
    >
      <BookOpen size={14} aria-hidden />
      Инструкция
    </button>
  );
}

export function HelpPanel({ markdown, onClose }: { markdown: string; onClose: () => void }) {
  useEffect(() => {
    const esc = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", esc);
    return () => window.removeEventListener("keydown", esc);
  }, [onClose]);
  return (
    <aside
      className="fixed inset-y-0 right-0 z-50 flex w-full max-w-[min(38rem,100vw)] flex-col border-l border-border bg-bg shadow-xl"
      style={{ paddingTop: "env(safe-area-inset-top, 0px)" }}
      role="dialog"
      aria-label="Инструкция"
      data-annot="панель инструкции"
    >
      <div className="flex items-center gap-3 border-b border-border px-5 py-3">
        <h2 className="text-[14px] font-semibold">Инструкция</h2>
        <button type="button" onClick={onClose} className="ml-auto rounded-[var(--radius-ui)] p-1 hover:bg-bg-hover" title="Закрыть (Esc)">
          <X size={16} aria-hidden />
          <span className="sr-only">Закрыть</span>
        </button>
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto px-5 pb-10 text-[14px] leading-[1.6]">
        <Prose>{markdown}</Prose>
      </div>
    </aside>
  );
}
